export default __webpack_public_path__ + "static/media/ticket36.dcdc6bfd.jpg";